export default __webpack_public_path__ + "static/media/port3.078adcd9.png";